import { render, staticRenderFns } from "./TheRecipientsAreaImport.vue?vue&type=template&id=416c6250&scoped=true"
import script from "./TheRecipientsAreaImport.vue?vue&type=script&lang=js"
export * from "./TheRecipientsAreaImport.vue?vue&type=script&lang=js"
import style0 from "./TheRecipientsAreaImport.vue?vue&type=style&index=0&id=416c6250&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416c6250",
  null
  
)

export default component.exports